module.exports = __webpack_public_path__ + "img/symbol_13.7168a6f9.png";